var scope = window.PANAMERICANA || {};
scope.views = {};
module.exports = scope;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/scope.js
// module id = 7
// module chunks = 14 15